<template>
    <form ref="form" @submit="handleConfirmAccount" novalidate>
        <div class="modal-dialog" style="min-width: 400px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirming Account Invitation</h5>
                </div>
                <div class="modal-body">
                    <div class="alert alert-danger" v-if="errorMessage">
                        {{errorMessage}}
                    </div>
                    <div class="alert alert-danger" v-if="errorDetails">                        
                        <ul id="error-details">
                            <li v-for="detail in errorDetails.split(',')" :key="detail">
                                {{ detail }}
                            </li>
                        </ul>
                    </div>
                    <div class="alert alert-success" v-if="successMessage">
                        {{successMessage}}
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>

export default {
    name: 'AlzataConfirmInviteAccount',
    data: () => ({        
        errorMessage: null,
        errorDetails: null,
        showPassword: false,
        busy: false,
        formWasValidated: false,
    }),
    mounted() {
        this.handleConfirmAccount();
    },
    methods: {        
        async handleConfirmAccount() {
            this.errorMessage = null;
            this.errorDetails = null;
            this.busy = true;
            let query = this.$route.query;            
            try {
                const result = await this.apiClient.confirmInvite(query.UserId, query.Token);
                if (result.success) {
                    this.successMessage = "Account Has Been Confirmed.";
                    window.setTimeout(() => this.$router.replace('/account/login'), 5000);
                }
                else {
                    this.errorMessage = "Failed To Confirm Account.";
                    this.errorDetails = result.displayMessage;                    
                }
            }
            finally {
                this.busy = false;
            }
        }
    },
};
</script>